import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=b9f94f24&"
import script from "./Student.vue?vue&type=script&lang=js&"
export * from "./Student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9f94f24')) {
      api.createRecord('b9f94f24', component.options)
    } else {
      api.reload('b9f94f24', component.options)
    }
    module.hot.accept("./Student.vue?vue&type=template&id=b9f94f24&", function () {
      api.rerender('b9f94f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Common/Student.vue"
export default component.exports